import React, { useEffect, useMemo, useState } from "react";
import "./App.css";
import items from "./shared/data";
import ItemCard from "./components/ItemCard/ItemCard";
import OrderCard from "./components/OrderCard/OrderCard";
import axios from "axios";

import { Layout, Row, Col, Typography, Space, Tag, Result, Modal } from "antd";

const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

interface Item {
  Image: string[];
  Price: number;
  Name: string;
  Desc: string;
}

interface FormValues {
  pib: string;
  email: string;
  phone: number;
  area: string;
  village: string;
  deliveryPoint: string;
}

function App() {
  const url = useMemo(() => new URLSearchParams(window.location.search), []);
  const [valid, setValid] = useState(false);

  const [item, setItem] = useState<Item | null>(null);
  const [quantity, setQuantity] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);

  const [successOpen, setSuccessOpen] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const param = url.get("item");
    if (!param) return;

    setValid(true);

    if (items[param]) {
      const it = items[param] as Item;
      setItem(it);
      setQuantity(1);
      setTotal(it.Price ?? 0);
    } else {
      setItem(null);
    }
  }, [url]);

  const handleQty = (qty: number, newTotal: number) => {
    setQuantity(qty);
    setTotal(newTotal);
  };

  const sendEmail = async (values: FormValues) => {
    if (!item) return;

    try {
      setSending(true);

      const request = {
        FormValues: values,
        quantity,
        total,
        item,
      };

      const res = await axios.post("https://eofycbygw15347x.m.pipedream.net", request);

      if (res.data?.success) {
        setSuccessOpen(true);
      } else {
        Modal.error({
          title: "Помилка",
          content: "Помилка з поштою. Перевірте введені дані.",
        });
      }
    } catch (e) {
      Modal.error({
        title: "Помилка",
        content: "Не вдалося відправити замовлення. Спробуйте ще раз.",
      });
    } finally {
      setSending(false);
    }
  };

  if (!valid || !item) {
    return (
      <div style={{ padding: 24 }}>
        <Result
          status="404"
          title="Товар не знайдено"
          subTitle="Перевірте посилання або параметр ?item="
        />
      </div>
    );
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header className="app-header">
        <div className="app-shell">
          <Space direction="vertical" size={0} style={{ width: "100%",  margin: 5, padding: 0, height: 64, lineHeight: 1 }}>
            <Title level={4} style={{ margin: 0, padding: 0 }}>
              Замовлення
            </Title>
            <Text type="secondary" style={{ margin: 0, padding: 0 }}>
              Оформлення доставки Новою Поштою
            </Text>
          </Space>
        </div>
      </Header>

      <Content className="app-content">
        <div className="app-shell">
          <Row gutter={[16, 16]} align="stretch">
            <Col xs={24} md={12} className="col-stretch">
              <ItemCard item={item} onQuantityChange={handleQty} />
            </Col>

            <Col xs={24} md={12} className="col-stretch">
              <OrderCard
                item={item}
                sendEmail={sendEmail}
                sending={sending}
                quantity={quantity}
                total={total}
              />
            </Col>
          </Row>
        </div>

        <Modal
          title="Замовлення"
          centered
          open={successOpen}
          onOk={() => setSuccessOpen(false)}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <p>Відправлено на опрацювання. Дякуємо за замовлення!</p>
        </Modal>
      </Content>

      <Footer style={{ textAlign: "center", background: "transparent" }}>
        <Text type="secondary">© {new Date().getFullYear()} nashi.com.ua</Text>
      </Footer>
    </Layout>
  );
}

export default App;
